// extracted by mini-css-extract-plugin
export default {"primaryButton":"primaryButton__Button__G7SG0","secondaryButton":"secondaryButton__Button__G7SG0","button":"button__Button__G7SG0"};